export const meta = {
  id: 'A02.1',
  slug: 'entender-resultado',
  title: 'Como entender o resultado do Diagnóstico',
  description: 'Interprete o resultado como uma referência atual para escolher prioridades e acompanhar sua evolução.',
  profile: 'student',
  category: 'diagnostico',
  type: 'concept',
  status: 'published',
  order: 70,
  keywords: ['resultado diagnóstico', 'nível atual', 'prioridade', 'competência', 'evolução'],
  previous: 'A02',
  next: 'A03',
  related: ['A03', 'A04'],
  updatedAt: '2026-08-17',
  appVersion: 'v1'
}

# Como entender o resultado do Diagnóstico

O resultado mostra uma **referência do seu momento atual** nas competências avaliadas. Ele ajuda a transformar percepção em prioridade de desenvolvimento.

## Como utilizar o resultado

Observe quais competências merecem mais atenção, relacione o resultado ao objetivo que você quer alcançar e use essa informação para orientar seu Desenvolvimento e Plano.

<HelpImage alt="Resultado do Diagnóstico do Aluno" pendingId="A02.4" />

<Callout type="concept">
  Um resultado de Diagnóstico não define quem você é. Ele registra um ponto de partida que pode mudar à medida que você aprende, pratica e evolui.
</Callout>

## O que acontece depois

O resultado pode apoiar a definição de objetivos e metas, a organização do seu Plano e as conversas com seu Mentor quando houver acompanhamento de Mentoria.
